import * as angular from "angular";
import {IController} from "angular";
import {PlanningViewSettingsJobsModel} from "../../../models/planning-view-settings.model";

export class PlanningDraftSettingsPanelTemplateComponent implements IController {

  settings: any;
  panelRef: any;

  public settingsCopy: any;
  public enabledSections: {
    columns: boolean,
    load: boolean
  };

  $onInit() {
    this.settingsCopy = angular.copy(this.settings);
    this.enabledSections = {
      columns: true,
      load: true
    }
  }

  onChangeColumns(columnKey, isEnabled) {
    this.settingsCopy.columns[columnKey] = isEnabled;
  }

  onChangeLoad(loadKey, isEnabled) {
    this.settingsCopy.load[loadKey] = isEnabled;
  }


  onSubmit() {
    this.panelRef.config.onCloseSuccess(this.panelRef, 'Submit', this.settingsCopy);
  }

  onReset() {
    this.panelRef.config.onCloseSuccess(this.panelRef, 'Reset');
  }

  onCancel() {
    this.panelRef.config.onCloseSuccess(this.panelRef, 'Cancel');
  }

}

angular
  .module('bringoz.admin.planning')
  .component('planningDraftSettingsPanelTemplate', {
    bindings: {
      settings: '<',
      panelRef: '<'
    },
    template: require('./planning-draft-settings-panel-template.html').default,
    controller: PlanningDraftSettingsPanelTemplateComponent
  });
